import { useSyncExternalStore } from "react";

/**
 * The width scripts/prerender.mjs snapshots every page at. Keep the two in
 * sync: it is what the prerendered HTML was laid out for.
 */
export const PRERENDER_VIEWPORT_WIDTH = 390;

function subscribe(breakpoint: number, onChange: () => void) {
  const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);
  mq.addEventListener("change", onChange);
  return () => mq.removeEventListener("change", onChange);
}

const subscribers = new Map<number, (onChange: () => void) => () => void>();
function subscriberFor(breakpoint: number) {
  let s = subscribers.get(breakpoint);
  if (!s) {
    s = (onChange) => subscribe(breakpoint, onChange);
    subscribers.set(breakpoint, s);
  }
  return s;
}

/**
 * Returns true when viewport width is ≤ 900px (matches NavBar mobile breakpoint).
 *
 * While React is adopting prerendered HTML it answers as the prerender saw the
 * page (390px wide, so mobile), then re-renders with the real width straight
 * after. That is useSyncExternalStore's server snapshot. Reading the window on
 * the first render instead made every desktop visit's first render differ from
 * the mobile snapshot, and React threw the prerendered page away and rebuilt
 * it (hydration error 418): the late LCP Clarity reported.
 */
export function useIsMobile(breakpoint = 900): boolean {
  return useSyncExternalStore(
    subscriberFor(breakpoint),
    () => window.innerWidth <= breakpoint,
    () => PRERENDER_VIEWPORT_WIDTH <= breakpoint,
  );
}
